import { createFileRoute } from "@tanstack/react-router"
import DesignSystemCheckboxes from "~/pages/design-system/components/Checkboxes"

export const Route = createFileRoute("/_auth/internal/design-system/components/checkboxes")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemCheckboxes />
}
